import { useState } from 'react';

interface UseRotateOptions {
  initialRotation?: number;
}

interface UseRotateReturn {
  rotation: number;
  setRotation: React.Dispatch<React.SetStateAction<number>>;
}

/**
 * Hook for handling rotation state of tools.
 * Scroll-wheel and drag-to-rotate are wired up natively in DraggableTool
 */
export function useRotate(options: UseRotateOptions): UseRotateReturn {
  const { initialRotation = 0 } = options;

  const [rotation, setRotation] = useState(initialRotation);

  return { rotation, setRotation };
}
